import { NavLink, useLocation } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';
import {
  primaryAdminNavItems,
  secondaryAdminNavItems,
  utilityAdminNavItems,
} from './adminNav';

export default function Sidebar({ isOpen = false, onClose = () => {}, isMobile = false }) {
  const location = useLocation();

  const containerClasses = [
    'fixed left-0 top-0 z-50 flex h-full w-64 flex-col border-r border-[#4e4632] bg-[#1c1b1b] transition-transform duration-300',
    isMobile ? (isOpen ? 'translate-x-0' : '-translate-x-full') : 'translate-x-0',
  ].join(' ');

  return (
    <aside className={containerClasses}>
      <div className="p-6">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded bg-[#ffcc00] text-[#3d2f00]">
            <MaterialIcon name="security" className="text-2xl" filled />
          </div>
          <div>
            <h2 className="font-['Geist'] text-[2rem] font-bold leading-none tracking-[-0.04em] text-[#ffedc3]">
              OPERATIONS
            </h2>
            <p className="mt-1 text-xs uppercase tracking-[0.18em] text-[#9a9078]">
              Active Session: Alpha-7
            </p>
          </div>
        </div>
      </div>

      <nav className="custom-scrollbar flex-1 overflow-y-auto px-2 pb-4">
        <div className="space-y-1">
          {primaryAdminNavItems.map((item) => (
            <SidebarLink
              key={item.to}
              item={item}
              active={location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)}
              onClick={isMobile ? onClose : undefined}
            />
          ))}
        </div>

        <div className="mt-6 px-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#8f866e]">
            More desks
          </p>
        </div>

        <div className="mt-2 space-y-1">
          {secondaryAdminNavItems.map((item) => (
            <SidebarLink
              key={item.to}
              item={item}
              active={location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)}
              onClick={isMobile ? onClose : undefined}
              compact
            />
          ))}
        </div>
      </nav>

      <div className="mt-auto border-t border-[#4e4632] px-4 py-4">
        {utilityAdminNavItems.map((item) => (
          <SidebarLink
            key={item.to}
            item={item}
            active={location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)}
            onClick={isMobile ? onClose : undefined}
            compact
          />
        ))}

        <button className="glow-orange mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-[#fd6c00] py-3 text-sm font-black tracking-[0.12em] text-[#341100] transition hover:brightness-110">
          <MaterialIcon name="emergency_home" className="text-lg" />
          EMERGENCY OVERRIDE
        </button>
      </div>
    </aside>
  );
}

function SidebarLink({ item, active = false, onClick, compact = false }) {
  return (
    <NavLink
      to={item.to}
      onClick={onClick}
      className={[
        'group flex items-center gap-4 px-4 transition-all',
        compact ? 'py-2.5' : 'py-3',
        active
          ? 'translate-x-1 border-l-4 border-[#ffcc00] bg-[#ffcc00] text-[#3d2f00]'
          : 'text-[#d2c5ab] hover:bg-[#2a2a2a] hover:text-[#e5e2e1]',
      ].join(' ')}
    >
      <MaterialIcon
        name={item.icon}
        className={compact ? 'text-base' : 'text-xl'}
        filled={active}
      />
      <span className={compact ? 'text-sm font-medium' : 'text-sm font-semibold'}>
        {item.label}
      </span>
    </NavLink>
  );
}
